module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step3-2-p-66e98d1f3e64c03932ea51eaa96a52b5.gif";